import { HttpService } from '@/data/http/http-service';
import { Organisation } from '@/domain/organisation/entities/organisation.entity';
import { OrganisationGateway } from '@/domain/organisation/gateways/organisation.gateway';

import {
  getOrganisationDtoSchema,
  organisationDtoSchema,
} from './organisation.dto.schema';
import { OrganisationMapper } from './organisation.mapper';

export class ApiOrganisationHttpGateway implements OrganisationGateway {
  private http = new HttpService({
    baseURL: import.meta.env.VITE_API_CONNECT,
  });

  async getOrganisation(): Promise<Organisation | null> {
    const url = '/organisation';
    const response = await this.http.get(url);
    const result = getOrganisationDtoSchema.safeParse(response.data);
    if (result.success === false) {
      console.error(result.error);
      throw result.error;
    }
    const result2 = organisationDtoSchema.safeParse(response.data);
    if (result2.success) {
      // case with one organisation
      const organisation: Organisation = OrganisationMapper.dtoToEntity(
        result2.data,
      );
      return organisation;
    } else {
      // case with no organisation
      return null;
    }
  }

  async createOrganisation(organisation: Organisation): Promise<void> {
    const url = '/organisation';
    const data = OrganisationMapper.entityToDto(organisation);
    const response = await this.http.post(url, data);
    if (response.status === 201) {
      return;
    } else {
      throw 'error on creation';
    }
  }

  async editOrganisation(organisation: Organisation): Promise<void> {
    const url = `/organisation/${organisation.id}`;
    const data = OrganisationMapper.entityToDto(organisation);
    const response = await this.http.patch(url, data);
    if (response.status === 200) {
      return;
    } else {
      throw 'error on edition';
    }
  }
}
